import { useQuery } from "react-query";

import useApiHelper from "../../services/useApiHelper";
import { IDefaultResponseWithData } from "../../models/system/DefaultResponse";
import useQSBuilder from "../../hooks/useQSBuilder";
import { newsletterQueryKeys } from "./queryKeys";
import { INewsletterStatistic } from "./../../models/emailSettings/EmailSettings";

export function useNewsletterStatistics(agencyId: string, fromDate: string) {
  const { get } = useApiHelper();
  const buildQs = useQSBuilder();

  const statistics = useQuery({
    queryKey: newsletterQueryKeys.statistics(agencyId, fromDate),
    queryFn: () =>
      get(
        `/marketing/${agencyId}/newsletter/statistics/${buildQs({
          date: fromDate,
        })}`
      ) as unknown as IDefaultResponseWithData<INewsletterStatistic>,
    refetchOnWindowFocus: false,
  });

  return {
    statistics,
  };
}
